import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, MenuController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { HomePage } from '../home/home';
import { AppVersion } from '@ionic-native/app-version';
import { AppConfig } from '../../providers/config';
@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  credentialsForm: FormGroup;
  versionnumber: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private auth: AuthProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public menu: MenuController,
    private platform: Platform,
    private appVersion: AppVersion
  ) {
    this.menu.enable(false);

    this.credentialsForm = this.formBuilder.group({
      email: [''],
      password: ['']
    });

    if (this.platform.is("cordova")) {
      // You are on a device, cordova plugins are accessible
      this.appVersion.getVersionNumber().then(version => {
        console.log(version);
        this.versionnumber = version;
      });
    } else {
      // Cordova not accessible, add mock data if necessary
      this.versionnumber = AppConfig.constants.MOCK_VERSION;
      console.log("Cordova not accessible " + this.versionnumber);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  
  ionViewWillEnter() {
    this.menu.enable(false);
    }
    
    
ionViewWillLeave() {
    this.menu.enable(true);
}

  async login() {
    let email = this.credentialsForm.controls.email.value;
    let password = this.credentialsForm.controls.password.value;
    if(!email || !password) {
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: 'Please enter a valid email and password',
        buttons: ['OK']
      });
      alert.present();
      return
    }
    const loader = this.loadingCtrl.create({
      content: "Signing In..."
    });

    loader.present()

    await this.auth.emailLogin(email, password)
    .then(() => {
      loader.dismiss()
      this.navCtrl.setRoot(HomePage)
    })
    .catch((err) => {
      console.log(err)
      let error: string = err.toString();
      error = error.replace('Error: Error: ','');
      loader.dismiss()
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: error,
        buttons: ['OK']
      });
      alert.present();
    });

    
  }

  async resetPassword() {
    const emailprompt = this.alertCtrl.create({
      title: 'Reset Password',
      inputs: [
        {
          name: 'email',
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Send Reset Email',
          handler: data => {
            let emailaddress = data.email;
            console.log("Email: ", emailaddress);
            const loader = this.loadingCtrl.create({
              content: "Sending Reset Email..."
            });
        
            loader.present()
        
            this.auth.sendPasswordResetEmail(emailaddress)
            .then(() => {
              loader.dismiss()
            })
            .catch(() => {
              loader.dismiss()
            });

        
            
          }
          }
      ]
    });
    emailprompt.present();
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts